"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styles_scss_1 = tslib_1.__importDefault(require("./styles.scss"));
var Input = /** @class */ (function (_super) {
    tslib_1.__extends(Input, _super);
    function Input() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Input.prototype.render = function () {
        var _a = this.props, value = _a.value, dataHook = _a.dataHook, className = _a.className, disabled = _a.disabled, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, setRef = _a.setRef, tabIndex = _a.tabIndex, ariaLabel = _a.ariaLabel;
        return (react_1.default.createElement("input", { type: "text", className: "".concat(styles_scss_1.default.input, " ").concat(className), "data-hook": dataHook, ref: setRef, "aria-label": ariaLabel, value: value, tabIndex: tabIndex, onChange: onChange, onBlur: onBlur, onFocus: onFocus, disabled: disabled }));
    };
    Input.defaultProps = {
        // TODO
        // Warning: Failed prop type: You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.
        onChange: function () { }, // placeholder for onChange to prevent warning
    };
    return Input;
}(react_1.default.Component));
exports.default = Input;
//# sourceMappingURL=input.js.map